export const data = [
    { id_vehicle_type: "1", name: "Carro" },
    { id_vehicle_type: "2", name: "Moto" },
    { id_vehicle_type: "3", name: "Caminhonete/Van" },
    // { id_vehicle_type: "4", name: "Ônibus" },
    // { id_vehicle_type: "5", name: "Caminhão" },
];

// icons
// icon: 'DirectionsCar'
// icon: 'Motorcycle'
// icon: 'LocalShipping'
// icon: 'DirectionsBus'